import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { resolveCssVariable } from '../theme';
import { IconSize } from './Icon';
import { LOGO_ICON_CLASS, tokens as iconTokens } from './tokens';
export const withLogoClass = (WrappedComponent)=>{
    return (props)=>{
        const iconSize = resolveCssVariable(iconTokens.Icon[props.size || IconSize.m].size);
        return /*#__PURE__*/ _jsx(WrappedComponent, {
            ...props,
            className: `${LOGO_ICON_CLASS} ${props.className || ''}`,
            width: props.width || iconSize,
            height: props.height || iconSize
        });
    };
};
export const withLogoClassAndGrayscale = (WrappedComponent)=>{
    return styled((props)=>{
        const iconSize = resolveCssVariable(iconTokens.Icon[props.size || IconSize.m].size);
        return /*#__PURE__*/ _jsx(WrappedComponent, {
            ...props,
            className: `${LOGO_ICON_CLASS} \${props.className || ""}`,
            width: props.width || iconSize,
            height: props.height || iconSize
        });
    })`
    filter: grayscale(1);
  `;
};
